import React from 'react';

import { SiteNav } from '../../components/SiteNav/SiteNav';
import { SiteFooter } from '../../components/SiteFooter/SiteFooter';
import { HeroSection } from './HeroSection';
import { WhatIsSection } from './WhatIsSection';
import { NoteSection } from './NoteSection';
import { CommunitySection } from './CommunitySection';
import { OutcomesSection } from './OutcomesSection';
import { AnatomySection } from './AnatomySection';
import { GettingStartedSection } from './GettingStartedSection';
import { FaqSection } from './FaqSection';
import { FinalCtaSection } from './FinalCtaSection';
import type { PageData } from './types';

export function Programs({
    csrfToken, hero, whatIs, note, community, outcomes, anatomy, gettingStarted, faq, finalCta,
}: PageData) {
    return (
        <div className="programs">
            <HeroSection data={hero} nav={<SiteNav />} />
            <WhatIsSection data={whatIs} />
            <CommunitySection data={community} />
            <NoteSection data={note} />
            <OutcomesSection data={outcomes} />
            <AnatomySection data={anatomy} />
            <GettingStartedSection data={gettingStarted} />
            <FaqSection data={faq} />
            <FinalCtaSection data={finalCta} />
            <SiteFooter csrfToken={csrfToken} />
        </div>
    );
}
